import * as Yup from 'yup';

export const DisapproveServiceOrderFormSchema = Yup.object().shape({
  reason: Yup.string().required(),
})

export const SigninInitialValues = {
  email: "",
  password: "",
}